// extracted by mini-css-extract-plugin
export default {"container":"Error_container__IX77P","textContainer":"Error_textContainer__Ujwgq","backButton":"Error_backButton__4-edP"};